export default "<app-new-loader *ngIf=\"!checkLoggedIn\"></app-new-loader>\n<router-outlet></router-outlet> \n"